import React from "react";
import { Box } from "@mui/material";
import { CustomButton } from "@ippon/shared-components";
import "../login/Login.css";

export type ResetSuccessPageProps = {
  renderLogo?: React.ReactNode;
  logoSrc?: string;
  logoAlt?: string;
  logoStyle?: React.CSSProperties;
  onLogin: () => void;
};

const ResetSuccessPage: React.FC<ResetSuccessPageProps> = ({
  renderLogo,
  logoSrc,
  logoAlt,
  logoStyle,
  onLogin,
}) => {
  return (
    <Box className="container">
      <Box className="formContainer">
        <Box className="fieldContainer">
          <Box className="logoContainer">
            {renderLogo ? (
              renderLogo
            ) : logoSrc ? (
              <img src={logoSrc} alt={logoAlt || "Logo"} style={logoStyle} />
            ) : null}
          </Box>

          <Box className="check_mail_content">
            <p className="check_mail_title">パスワードの再設定が完了しました。</p>
            <p
              style={{
                fontSize: "12px",
                color: "#3e3e3e",
                margin: 0,
                textAlign: "center",
                lineHeight: 1.6,
              }}
            >
              「ログイン」でお進みください。
            </p>
          </Box>

          <CustomButton
            type="button"
            label="ログイン"
            onClick={onLogin}
            fullWidth
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ResetSuccessPage;
